<template>
  <div class="container mx-auto p-4">
    <AlertLayout title="Reminders!"
      message="Kindly note that only blood units registered on Damu-Sasa will be found by the search.<br>Non-registered units should 1st be registered."
      type="warning" class="mb-4" />
    <div class="bg-white border border-t-0 rounded-lg shadow-md p-5">
      <h2 class="text-xl font-bold mb-2">Donation Information</h2>

      <div class="bg-gray-10 p-6 rounded-lg mb-6">
        <div class="grid grid-cols-2 gap-4">
          <!-- Left Column -->
          <div class="space-y-6">
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-sm font-normal mt-3">Serial Number:</label>
              <p class="text-sm font-semibold mt-3">
                {{ external_screening.pint_serial }}
              </p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-sm font-normal mt-3">Blood Group:</label>
              <p class="text-sm font-semibold mt-3">{{ external_screening.blood_group?.description ?? 'Unknown' }}</p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-sm font-normal mt-3">Blood Product:</label>
              <p class="text-sm font-semibold mt-3">{{ external_screening.unit_product?.name ?? 'unknown' }}</p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-sm font-normal mt-3">Blood Volume:</label>
              <p class="text-sm font-semibold mt-3">{{ external_screening.quantity }} ml</p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-sm font-normal mt-3">Added By:</label>
              <p class="text-sm font-semibold mt-3">{{ external_screening.added_by?.first_name ?? '' }} {{ external_screening.added_by?.last_name ?? '' }} </p>
            </div>
            
          </div>
          <!-- Right Column -->
          <div class="space-y-6">
           
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-sm font-normal mt-3">Blood Origin:</label>
              <p class="text-sm font-semibold mt-3">{{ external_screening.origin }}</p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-sm font-normal mt-3">Expiry Date:</label>
              <p class="text-sm font-semibold mt-3">{{ external_screening.expiry_date }}</p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-sm font-normal mt-3">Blood Status:</label>
              <p class="text-sm font-semibold mt-3">{{ external_screening.status }}</p>
            </div>
            <div class="grid grid-cols-2 items-center border-t m-2">
              <label class="text-sm font-normal mt-3">Approved By:</label>
              <p class="text-sm font-semibold mt-3">{{ external_screening.approved_by?.first_name ?? '' }} {{ external_screening.approved_by?.last_name ?? '' }} </p>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-8">
        <h2 class="text-xl font-semibold mb-4">Screening Results</h2>
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200 border border-gray-200 rounded-lg shadow-md">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-6 py-3 text-left text-sm tracking-wider">Hepatitis B</th>
                <th class="px-6 py-3 text-left text-sm tracking-wider">Hepatitis C</th>
                <th class="px-6 py-3 text-left text-sm tracking-wider">HIV</th>
                <th class="px-6 py-3 text-left text-sm tracking-wider">Malaria</th>
                <th class="px-6 py-3 text-left text-sm tracking-wider">VDRL</th>
                <th class="px-6 py-3 text-left text-sm tracking-wider">Blood Clot</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr>
                <td class="px-6 py-4 whitespace-nowrap text-sm">{{ external_screening.hepatitis_b }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm">{{ external_screening.hepatitis_c }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm">{{ external_screening.hiv  }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm">{{ external_screening.malaria}}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm">{{ external_screening.vdrl}}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm">{{ external_screening.blood_clot}}</td>
              </tr>
              <tr class="bg-gray-50">
                <td v-for="test in testTypes" :key="test" class="px-6 py-4 whitespace-nowrap text-sm">
                  <div class="text-xs">
                    Done by: {{ getPersonnelInfo(test, 'done_by') }}<br>
                    Confirmed by: {{ getPersonnelInfo(test, 'confirmed_by') }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="flex justify-start">
        <div>
          <button class="px-4 py-2 border rounded text-orange-500 border-orange-500 mr-2"
            @click="handleBackToUnitDetails">
            Back
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AlertLayout from '@/components/AlertLayout.vue';
import api from '@/services/api';

export default {
  name: 'ExternalUnitDetailsPage',
  components: {
    AlertLayout,
  },
  data() {
    return {
      external_screening: [],
      products: [],
      external_screening_id: '',
      totalVolume: 0,
      error: null,
      showDeferralPopup: false,
      testTypes: [
        'hepatitis_b',
        'hepatitis_c',
        'hiv',
        'malaria',
        'vdrl',
        'blood_clot'
      ]
    };
  },
  created() {
    this.external_screening_id = this.$route.params.external_screening_id;
    this.getExternalScreeningUnit();
  },

  methods: {
    user() {
      return this.$store.getters["auth/user"];
    },
    handleBackToUnitDetails() {
      this.$router.push({ name: 'InventoryManagementPage' });
    },
    
    async getExternalScreeningUnit() {
      try {
        const response = await api.getExternalScreening(this.external_screening_id);
        this.external_screening = response.data || response;
      } catch (error) {
        this.error = error.message || 'Failed to fetch external unit';
      }
    },
    getPersonnelInfo(testType, role) {
      const log = this.external_screening.external_sreening_logs?.find(log => log.property === testType)
      if (!log || !log[role]) return ''
      return `${log[role].first_name} ${log[role].last_name}`
    }
  },
};
</script>